export const medicalHistoryTableHeaders = [
  "date",
  "condition",
  "consultationType",
  "View",
];
